import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, TrendingUp } from 'lucide-react';
interface HallmarkSlide5Props {
  isDark?: boolean;
}
export function HallmarkSlide5({
  isDark = false
}: HallmarkSlide5Props) {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.12,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  return <motion.div className="h-full w-full overflow-y-auto overflow-x-hidden" variants={containerVariants} initial="hidden" animate="visible" data-id="element-79">
      <div className="min-h-full flex flex-col justify-center max-w-6xl mx-auto px-6 sm:px-12 py-20 sm:py-24" data-id="element-80">
        {/* Header */}
        <motion.div variants={itemVariants} className="text-center mb-12 sm:mb-16" data-id="element-81">
          <h1 className={`text-3xl sm:text-5xl font-serif font-medium mb-4 sm:mb-6 tracking-tight ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-82">
            How We Define Success
          </h1>
        </motion.div>

        {/* Two Columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12" data-id="element-83">
          {/* Left Column - Participation */}
          <motion.div variants={itemVariants} data-id="element-84">
            <div className={`rounded-3xl p-8 sm:p-10 h-full ${isDark ? 'bg-white/[0.03] border border-white/10' : 'bg-white border border-heliona-beige'}`} data-id="element-85">
              <div className="flex items-center gap-4 mb-8" data-id="element-86">
                <div className={`p-3 rounded-2xl ${isDark ? 'bg-heliona-mint/20' : 'bg-heliona-mint/10'}`} data-id="element-87">
                  <CheckCircle className={`w-8 h-8 ${isDark ? 'text-heliona-mint' : 'text-heliona-mint-dark'}`} data-id="element-88" />
                </div>
                <h2 className={`text-2xl font-bold ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-89">
                  Participation Benchmarks
                </h2>
              </div>

              <ul className="space-y-6" data-id="element-90">
                {['85–90% baseline completion', '70%+ engagement', '50%+ care pathway activation', '60%+ learning engagement'].map((item, idx) => <li key={idx} className="flex items-center gap-4" data-id="element-91">
                    <div className={`w-2 h-2 rounded-full ${isDark ? 'bg-heliona-mint' : 'bg-heliona-mint-dark'}`} data-id="element-92"></div>
                    <span className={`text-lg ${isDark ? 'text-white/80' : 'text-heliona-text-gray'}`} data-id="element-93">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </motion.div>

          {/* Right Column - Outcomes */}
          <motion.div variants={itemVariants} data-id="element-94">
            <div className={`rounded-3xl p-8 sm:p-10 h-full ${isDark ? 'bg-heliona-navy/30 border border-heliona-navy/50' : 'bg-heliona-navy/5 border border-heliona-navy/10'}`} data-id="element-95">
              <div className="flex items-center gap-4 mb-8" data-id="element-96">
                <div className={`p-3 rounded-2xl ${isDark ? 'bg-heliona-orange/20' : 'bg-heliona-orange/10'}`} data-id="element-97">
                  <TrendingUp className="w-8 h-8 text-heliona-orange" data-id="element-98" />
                </div>
                <h2 className={`text-2xl font-bold ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-99">
                  Outcome Indicators
                </h2>
              </div>

              <ul className="space-y-6" data-id="element-100">
                {['Capacity improvement trend', 'Clarity lift during change', 'Burnout risk reduction', 'Reduced internal friction', 'Increased leadership confidence'].map((item, idx) => <li key={idx} className="flex items-center gap-4" data-id="element-101">
                    <div className="w-2 h-2 rounded-full bg-heliona-orange" data-id="element-102"></div>
                    <span className={`text-lg ${isDark ? 'text-white/80' : 'text-heliona-text-gray'}`} data-id="element-103">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </motion.div>;
}